import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { logError } from '@/helpers/log-helper';

function StoreAvailability(_x, _x2, _x3) {
  return _StoreAvailability.apply(this, arguments);
}

function _StoreAvailability() {
  _StoreAvailability = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context, reference, zipcode) {
    var locale, xhrUri, _ref, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "/nav/nav-api/product/".concat(locale.market, "/").concat(locale.language, "/shops-by-address/").concat(reference, "/").concat(zipcode);
            _context.prev = 2;
            _context.next = 5;
            return context.$axios.get(xhrUri, {
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            });

          case 5:
            _ref = _context.sent;
            data = _ref.data;
            return _context.abrupt("return", data);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            logError({
              msg: _context.t0,
              context: context
            });
            return _context.abrupt("return", null);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));
  return _StoreAvailability.apply(this, arguments);
}

export default StoreAvailability;